interface CSSStyles {
    large: string;
    medium: string;
    small: string;
    sectionTitle: string;
    sectionSubtitle: string;
    body: string;
    bodyBold: string;
    navigation: string;
  }
  
  const CSSStyles: CSSStyles = {
    large: "large-style",
    medium: "medium-style",
    small: "small-style",
    sectionTitle: "section-title-style",
    sectionSubtitle: "section-subtitle-style",
    body: "body-style",
    bodyBold: "body-bold-style",
    navigation: "navigation-style",
  };
    
  export default CSSStyles;
  